<template>
  <div class="d-flex flex-row align-items-center justify-content-start">
    <label v-if="label" class="mr-3">{{ label }}</label>
    <h3
      v-if="showZero ? (value !== null && value !== undefined) : value"
      :class="`my-0 text-muted ${!mr ? `mr-3` : ``}`"
      :style="styles"
    >
      {{ value }}
    </h3>
    <button class="mr-2 btn btn-info custom-shadow-btn" @click="handlePlus">
      <em class="fa fa-plus"></em>
    </button>
    <button class="btn btn-info custom-shadow-btn" @click="handleMinus">
      <em class="fa fa-minus"></em>
    </button>
  </div>
</template>
<script>
export default {
  name: 'minus-plus',
  props: {
    label: {
      type: String,
    },
    value: {
      type: Number,
      default: 0,
    },
    mr: {
      type: String,
      default: null,
    },
    indexPosition: {
      type: Number,
      default: 0,
    },
    showZero: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    styles() {
      if (this.mr)
        return {
          'margin-right': this.mr,
        };
      else return {};
    },
  },
  methods: {
    handlePlus() {
      this.$emit('handlePlus', this.indexPosition);
    },
    handleMinus() {
      this.$emit('handleMinus', this.indexPosition);
    },
  },
};
</script>
